/*********************************************************
 *                  Admin overview Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("OverviewCtrl", ["$http", "$scope", "clients", "ExploitationService", "AdminClientsService", "OpenImportsService", "OpenExportsService", "SecurityService" ,
		function ($http, $scope, clients, ExploitationService, AdminClientsService, OpenImportsService, OpenExportsService, SecurityService) {
		$scope.data = {
			clients: clients.data
		};


		$scope.hasRight = (rightName) => SecurityService.hasRight(rightName);

		$scope.data.clients = $scope.data.clients.filter(c => c.code.indexOf("mobiiti_") !== 0);

		if (SecurityService.hasRight('predefinedExportsOrgList')) {
			$scope.selectedClient = 'Toutes';
		} else {
			$scope.selectedClient = 'Technique';
		}

		$scope.loadOverviewBySchema = function () {
			if($scope.selectedClient === "Toutes"){
				$scope.loadOverviewAllSchema();
			}

			if ($scope.selectedClient === "Technique") {
				ExploitationService.getOverviewPredefinedExportsBySchema("technique").then((response) => {
					$scope.data.overview = response.data;
				})
			}

			$scope.client = $scope.data.clients.find(c => c.name === $scope.selectedClient)
			if ($scope.client) {
				ExploitationService.getOverviewPredefinedExportsBySchema($scope.client.code).then((response) => {
					$scope.data.overview = response.data;
				})
			}
		}

		$scope.loadOverviewAllSchema = function () {
				ExploitationService.getOverviewPredefinedExportsAllSchema().then((response) => {
					$scope.data.overview = response.data;
				})
		}


		/**
		 * Function to check if a date is obsolete or not
		 * @param date
		 * 		date to check
		 * @returns {boolean}
		 * 		true : the param date is before today
		 * 		false : the param date is after today
		 */
		$scope.isPassedDate = function (date) {
			let dateToCheck = new Date(Date.parse(date));

			let dateNowWithoutTime = new Date(Date.now());
			dateNowWithoutTime.setHours(0);
			dateNowWithoutTime.setMinutes(0);
			dateNowWithoutTime.setSeconds(0);
			dateNowWithoutTime.setMilliseconds(0);

			return dateToCheck.getTime() < dateNowWithoutTime.getTime();
		};

		/**
		 * Function to check is an export is obsolate or not (an export is obsolete if a new import has been done after this export)
		 * @param importDateMillis
		 * 		date of the last import in millis
		 * @param exportDateMillis
		 * 		date of the last export in millis
		 * @returns {boolean}
		 * 		true : the export is obsolete
		 * 		false : the export is up-to-date
		 */
		$scope.isExportObsolete = function (importDateMillis, exportDateMillis) {

			if (exportDateMillis === null || exportDateMillis === 'undefined' || importDateMillis === null || importDateMillis === 'undefined'){
				return false;
			}

			let importDate =  new Date(importDateMillis);
			let exportDate =  new Date(exportDateMillis);
			return importDate > exportDate;

		}

		/**
		 * Converts a date in millis to a human readable date (YYYY-MM-dd)
		 * @param dateMillis
		 * 		the date in millis
		 * @returns {string}
		 * 		the human readable date
		 */
		$scope.formatDate = function (dateMillis) {

			if (!dateMillis || dateMillis === null || dateMillis == 'undefined'){
				return "";
			}

			let date =  new Date(dateMillis);
			let realMonth = date.getMonth() + 1;
			return date.getFullYear() + "-" + fillWithZero(realMonth) + "-" + fillWithZero(date.getDate());
		}

		/**
		 * Function to add a 0 for numbers lower than 10 (to always have a 2-digit number)
		 * @param rawNumber
		 * 		the number
		 * @returns {string|*}
		 * 		the number on 2 digits
		 */
		function fillWithZero( rawNumber ) {
			if (rawNumber < 10){
				return "0" + rawNumber;
			}
			return rawNumber;
		}

		/**
		 * Read all schemas to add import and export data
		 * @returns {Promise<void>}
		 *
		 */
		async function  fillImportExportInfos() {
			 let clientList = $scope.data.clients.filter(c => c.code !== 'technique');

			 for (var i=0; i < clientList.length; i++){
			 	let currClient = clientList[i];

			 	const provider = await AdminClientsService.getProvider(currClient.code);
			 	OpenImportsService.getLatestMobiitiImport(provider.id)
				    				.then((response) => {
										const data = response.data;
				    					if (data !== null && data !== 'undefined' && data.length >0){
											setParamForProvider(provider.name,"lastImportDate", data[0].lastEvent);
										}
				 					});

				 OpenExportsService.getLatestExport(provider.id)
					 .then((response) => {
						 const data = response.data;
						 if (data !== null && data !== 'undefined' && data.length >0){
							 setParamForProvider(provider.name,"lastExportDate", data[0].lastEvent);
							 setParamForProvider(provider.name,"exportType", data[0].type);
						 }
					 });
			 }

		}

		/**
		 * Fill a value in a provider data
		 * @param provider
		 * 		the provider for which value must be written
		 * @param param
		 * 		the kind of param to write
		 * @param value
		 * 		the value to write
		 */
		function setParamForProvider( provider, param,  value ) {

			let provToUpdate = $scope.data.synthesis.find(c => c.referential === provider);

			if (provToUpdate == null || provToUpdate === 'undefined'){
				return ;
			}

			if (param === "lastImportDate"){
				provToUpdate.lastImportDate = value;
			}

			if (param === "lastExportDate"){
				provToUpdate.lastExportDate = value;
			}

			if (param === "exportType"){
				provToUpdate.exportType = value;
			}

		}

		/**
		 * Function to compare 2 synthesis date, on referential name
		 * @param synthA
		 * 		the first synthesis to compare
		 * @param synthB
		 * 		the second synthesis to compare
		 * @returns {number}
		 * 		result of the comparison
		 */
		function synthesisComparison( synthA, synthB ) {
			if ( synthA.referential < synthB.referential ){
				return -1;
			}
			if ( synthA.referential > synthB.referential ){
				return 1;
			}
			return 0;
		}


		$scope.loadOverviewBySchema();


		//Recover the synthesis data for all schemas
		ExploitationService.getSynthesisAllSchema().then((response) => {
			$scope.data.synthesis = response.data.filter(c => c.referential !== 'technique')
				.sort(synthesisComparison);

				fillImportExportInfos();


		});




	}]);

